import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RestaurantService } from '../../../services/restaurant/restaurant.service';
import { NotifierService } from 'angular-notifier';
import { AnyIntegration } from '../../../interfaces/restaurant';
import { filter, take } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-edit-integration',
  templateUrl: './edit-integration.component.html',
  styleUrls: ['./edit-integration.component.scss']
})
export class EditIntegrationComponent implements OnInit {
  loading = true;
  public restaurantId!: number;
  public integration!: AnyIntegration;
  private integrationId!: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private restaurantService: RestaurantService,
    public dialogRef: MatDialogRef<any>,
    public notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.restaurantId = this.data.restaurantId;
    this.integrationId = this.data.integrationId;
    this.getIntegration();
  }

  getIntegration(): void {
    this.restaurantService.getIntegrationById(this.restaurantId, this.integrationId).pipe(
      take(1)
    ).subscribe((integration) => {
      this.integration = integration;
      this.loading = false;
    });
  }

  public editIntegration(formValue: Partial<AnyIntegration>): void {

    this.integration.proxy = !!formValue.proxy;
    this.integration.proxyUnifiedMode = !!formValue.proxyUnifiedMode;

    if (formValue.credentials) {
      this.integration.credentials = formValue.credentials;
    }

    this.restaurantService.editIntegration(this.restaurantId, this.integration).pipe(
      filter(Boolean),
      untilDestroyed(this),
    ).subscribe((data) => {
      this.loading = false;
      this.dialogRef.close(data);
      this.notifier.notify('success', this.translate.instant('pages.restaurantAccount.messages.editedIntegration'));
    });
  }

  public removeIntegration(): void {
    this.loading = true;

    this.restaurantService.removeIntegration(this.restaurantId, this.integrationId).pipe(
      untilDestroyed(this),
    ).subscribe(() => {
      this.loading = false;
      this.dialogRef.close(this.integrationId.toString());
      this.notifier.notify('success', this.translate.instant('pages.restaurantAccount.messages.deletedIntegration'));
    });
  }
}
